import { IAccessKey } from "./interfaces/IAccessKey";
import moment from "moment";

export default class AccessKey implements IAccessKey {
  keyType: string;
  accessKey: string;
  expirationDate: string | null = moment().format('YYYY-MM-DD');
  showDatePicker: boolean = false;

  constructor(keyType: string = "", accessKey: string = "", expirationDate: string = "") {
    this.keyType = keyType;
    this.accessKey = accessKey;
    this.expirationDate = expirationDate;
  }
}
